import React from "react";
import { Card, Grid, CircularProgress } from "@mui/material";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import VuiProgress from "components/VuiProgress";
import colors from "assets/theme/base/colors";
import rgba from "assets/theme/functions/rgba";
import linearGradient from "assets/theme/functions/linearGradient";
import { IoOpenOutline } from "react-icons/io5";
import useCommon from "hooks/useCommon";

function ReferralTracking({
  title = "Guest Insights",
  leftCards = [],
  scoreLabel = "Returning",
  scoreValue = "34%",
  scoreSubLabel = "Guest Ratio",
  progressValue = 34,
}) {
  const { NAVIGATE } = useCommon();
  const { gradients, primary, light, dark } = colors;
  const { cardContent } = gradients;

  const topCards = leftCards.filter((x) => x.fullWidth);
  const bottomCards = leftCards.filter((x) => !x.fullWidth);

  return (
    <Card
      sx={{
        height: "100%",
        p: 1.5,
        // background: linearGradient(
        //   gradients.cardDark.main,
        //   gradients.cardDark.state,
        //   gradients.cardDark.deg
        // ),
      }}
    >
      <VuiBox>
        <VuiTypography variant="lg" fontWeight="regular" sx={{ fontSize: 17 }}>
          {title}
        </VuiTypography>

        <VuiBox display="flex" justifyContent="center" mb={1}>
          <VuiBox sx={{ position: "relative", display: "inline-flex", borderRadius: "50%", background: "linear-gradient(180deg, #1b2e24 15%, #c4c9c2 85%, #f5f4f1)", "&::before": { content: '""', position: "absolute", inset: 8, borderRadius: "50%", background: "#faf9f7" } }}>
            <CircularProgress
              variant="determinate"
              value={progressValue}
              size={140}
              thickness={2.5}
              sx={{ color: primary.main }}
            />

            <VuiBox
              sx={{
                inset: 0,
                position: "absolute",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <VuiBox textAlign="center">
                <VuiTypography variant="button" fontWeight="regular" sx={{ fontSize: 10 }}>
                  {scoreLabel}
                </VuiTypography>

                <VuiTypography variant="h2" fontWeight="medium" lineHeight={1} sx={{ fontSize: 32, my: 0.5 }}>
                  {scoreValue}
                </VuiTypography>

                <VuiTypography variant="button" fontWeight="regular" sx={{ fontSize: 10 }}>
                  {scoreSubLabel}
                </VuiTypography>
              </VuiBox>
            </VuiBox>
          </VuiBox>
        </VuiBox>

        {/* Top  card */}
        {topCards.map((card, index) => (
          <VuiBox
            key={index}
            py={1}
            px={0}
            borderRadius="0px"
            mb={1}
            sx={{
              // background: light.secondary,
              borderBottom: "1px solid #dedfd9",
            }}
          >
            <VuiBox display="flex" alignItems="center" justifyContent="space-between" mb={0.5}>
              <VuiBox display="flex" alignItems="center" gap={1}>
                {card.icon}

                <VuiTypography variant="caption" sx={{ fontSize: 12 }}>{card.label}</VuiTypography>
              </VuiBox>

              {!!card.route && (
                <VuiBox
                  onClick={() => NAVIGATE(card.route)}
                  sx={{
                    width: 24,
                    height: 24,
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                    color: "#A0AEC0",

                    "&:hover": {
                      background: "rgba(255,255,255,0.08)",
                      color: "#fff",
                    },
                  }}
                >
                  <IoOpenOutline size={13} color={dark.main} />
                </VuiBox>
              )}
            </VuiBox>

            <VuiTypography variant="h6" fontWeight="medium" sx={{ fontSize: 13 }}>
              {card.value}
            </VuiTypography>
          </VuiBox>
        ))}

        {/* Bottom cards */}
        <Grid container spacing={2}>
          {bottomCards.map((item, index) => (
            <Grid item xs={6} key={index}>
              <VuiBox
                py={1}
                px={0}
                borderRadius="0px"
                sx={{
                  borderLeft: index > 0 ? "1px solid #c7cbc4" : "none",
                  pl: index > 0 ? 2 : 0,
                }}
              >
                <VuiBox display="flex" alignItems="center" gap={1} mb={1}>
                  {item.icon}
                  <VuiTypography variant="caption" sx={{ fontSize: 12 }}>{item.label}</VuiTypography>
                </VuiBox>

                <VuiTypography variant="h6" fontWeight="regular" sx={{ fontSize: 16 }}>
                  {item.value}
                </VuiTypography>
              </VuiBox>
            </Grid>
          ))}
        </Grid>
      </VuiBox>
    </Card>
  );
}

export default ReferralTracking;
